var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "offerDetailsPopin",
      staticClass: "modal fade pt-popin-cds",
      attrs: {
        id: "offer-details-popin",
        "aria-labelledby": "offer-details-popin",
        tabindex: "-1",
        role: "dialog",
        "aria-hidden": "true",
        "data-ob1-component": "Popin",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content pb-0 px-1 px-md-2" }, [
          _c("div", [
            _c(
              "div",
              { staticClass: "modal-header" },
              [
                _vm.activeView !== "offer-content"
                  ? _c("Lien", {
                      attrs: {
                        id: "back-button",
                        "is-button": true,
                        "is-mini": true,
                        "is-link-arrow-back": true,
                        label: "Retour",
                      },
                      on: { click: _vm.goBack },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-close ob1-link-arrow back",
                    staticStyle: { display: "none !important" },
                    attrs: { type: "button", "data-bs-dismiss": "modal" },
                  },
                  [
                    _vm._v(
                      "\n                        Fermer\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body px-0" }, [
              _vm.activeView === "offer-content"
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 px-2 px-md-3 px-lg-5" }, [
                      _c("div", { staticClass: "h4 mb-0" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.dto.title) +
                            "\n                            "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 px-2 px-md-3 px-lg-5" }, [
                      _c(
                        "nav",
                        {
                          staticClass: "ob1-menu-page",
                          staticStyle: { height: "auto !important" },
                        },
                        [
                          _c(
                            "ul",
                            { staticClass: "nav ob1-nav-light" },
                            _vm._l(_vm.dto.items, function (item, itemIndex) {
                              return _c(
                                "li",
                                {
                                  key:
                                    item && item.name
                                      ? item.name
                                      : `CrossSellOffer-${itemIndex}`,
                                  staticClass: "nav-item",
                                  class: {
                                    active:
                                      item.seoId === _vm.selectedOffer.seoId,
                                  },
                                },
                                [
                                  _c("button", {
                                    staticClass: "nav-link px-0",
                                    attrs: {
                                      "data-oevent-category":
                                        "offer_details_popin",
                                      "data-oevent-action": _vm.getActionTms(
                                        item.secondaryShortLabel
                                      ),
                                      "data-oevent-label": item.seoId,
                                    },
                                    domProps: {
                                      textContent: _vm._s(
                                        item.secondaryShortLabel
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeSelectedTab(item)
                                      },
                                    },
                                  }),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "my-1 col-12 px-2 px-md-3 px-lg-5" },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-10" }, [
                                _vm.showBanner(_vm.selectedOffer.banner)
                                  ? _c("strong", {
                                      directives: [
                                        {
                                          name: "msh-html",
                                          rawName: "v-msh-html",
                                          value: _vm.selectedOffer.banner,
                                          expression: "selectedOffer.banner",
                                        },
                                      ],
                                      staticClass:
                                        "ob1-tag ob1-tag-primary mb-1",
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("h2", { staticClass: "visually-hidden" }, [
                                  _vm._v(
                                    "\n                                                " +
                                      _vm._s(
                                        _vm.nameAccessibility(_vm.selectedOffer)
                                      ) +
                                      "\n                                            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass: "fw-bold py-0 mb-0",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                " +
                                        _vm._s(_vm.selectedOffer.offerType) +
                                        "\n                                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "h2",
                                  {
                                    staticClass: "h1 py-0 mb-0",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                                " +
                                        _vm._s(
                                          _vm.selectedOffer.secondaryShortLabel
                                        ) +
                                        "\n                                            "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-2 d-flex justify-content-end",
                                },
                                [
                                  _vm.selectedOffer.showPicto5G
                                    ? _c("img", {
                                        staticClass: "logo-5g-popin",
                                        attrs: {
                                          src: _vm.selectedOffer.picto5gSrc,
                                          alt: "logo 5G Orange",
                                          "aria-hidden": "true",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-2" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "div",
                                  {
                                    class: _vm.showOpenDiscountMessage
                                      ? "my-1 px-1 bg-greige"
                                      : "mt-1 mb-0",
                                  },
                                  [
                                    _vm.showOpenDiscountMessage
                                      ? [
                                          _c("div", {
                                            staticClass:
                                              "fw-bold small text-dark pt-1 pb-0 pe-1",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.selectedOffer
                                                  .openDiscountMessage
                                              ),
                                            },
                                          }),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("PriceWithDetails", {
                                      staticClass: "price-align",
                                      attrs: {
                                        price: _vm.selectedOffer.price,
                                        "price-details-popin":
                                          _vm.selectedOffer.priceDetailsPopin ??
                                          undefined,
                                        "offer-id-seo": _vm.selectedOffer.seoId,
                                        "offer-name": _vm.selectedOffer.name,
                                        "tracking-category":
                                          "offer_details_popin",
                                        "is-black": false,
                                        "is-embedded-details": true,
                                      },
                                      on: {
                                        "show-details": _vm.showPriceDetails,
                                      },
                                    }),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.selectedOffer.monthlyOdrs &&
                              !_vm.selectedOffer.priceDetailsPopin
                                ? _c("div", { staticClass: "col-12" }, [
                                    _c(
                                      "ul",
                                      {
                                        staticClass: "row list-unstyled mb-0",
                                        attrs: {
                                          "aria-label":
                                            "Offres de réductions mensuelles du forfait",
                                        },
                                      },
                                      _vm._l(
                                        _vm.selectedOffer.monthlyOdrs,
                                        function (odr, index) {
                                          return _c(
                                            "li",
                                            { key: index },
                                            [
                                              _c("InlinePromise", {
                                                attrs: {
                                                  claim: {
                                                    attributes: {
                                                      textHtml: odr,
                                                    },
                                                  },
                                                  "is-warning": true,
                                                  "compact-text": true,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedOffer.claims &&
                              _vm.selectedOffer.claims.length > 0
                                ? _c(
                                    "div",
                                    {
                                      class: _vm.selectedOffer.priceDetailsPopin
                                        ? "col-12 pt-1"
                                        : "col-12",
                                    },
                                    [
                                      _c(
                                        "ul",
                                        {
                                          staticClass: "row list-unstyled mb-0",
                                          attrs: {
                                            "aria-label":
                                              "Avantages du forfait",
                                          },
                                        },
                                        _vm._l(
                                          _vm.selectedOffer.claims,
                                          function (claim, index) {
                                            return _c(
                                              "li",
                                              [
                                                _c("InlinePromise", {
                                                  key: `claim-${index}`,
                                                  attrs: { claim: claim },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-4" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "accordion",
                                    attrs: {
                                      itemscope: "",
                                      itemtype: "https://schema.org/FAQPage",
                                    },
                                  },
                                  _vm._l(
                                    _vm.selectedOffer.detailAttributes || [],
                                    function (detailAttribute, attributeIndex) {
                                      return _c(
                                        "div",
                                        {
                                          key: `${_vm.selectedOffer.idSeo}-${attributeIndex}`,
                                          staticClass: "card multi",
                                          attrs: {
                                            itemscope: "",
                                            itemprop: "mainEntity",
                                            itemtype:
                                              "https://schema.org/Question",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "card-header" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "collapsed",
                                                  attrs: {
                                                    id: `faqQuestion-${_vm.selectedOffer.idSeo}-${attributeIndex}`,
                                                    "data-bs-toggle":
                                                      "collapse",
                                                    "data-bs-target": `#faqAnswer-${_vm.selectedOffer.idSeo}-${attributeIndex}`,
                                                    "aria-controls": `faqAnswer-${_vm.selectedOffer.idSeo}-${attributeIndex}`,
                                                    "aria-expanded": "false",
                                                    type: "button",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "accordion-card-title",
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "accordion-title mb-0",
                                                          attrs: {
                                                            itemprop: "name",
                                                          },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                detailAttribute.titleAttribute
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("p", {
                                                        staticClass:
                                                          "accordion-icon mb-0",
                                                        attrs: {
                                                          "aria-hidden": "true",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "collapse",
                                              attrs: {
                                                id: `faqAnswer-${_vm.selectedOffer.idSeo}-${attributeIndex}`,
                                                "aria-labelledby": `faqQuestion-${_vm.selectedOffer.idSeo}-${attributeIndex}`,
                                                role: "region",
                                                itemscope: "",
                                                itemprop: "acceptedAnswer",
                                                itemtype:
                                                  "https://schema.org/Answer",
                                              },
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "accordion-card-body standard",
                                                attrs: { itemprop: "text" },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    detailAttribute.textAttribute
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.selectedOffer.legalMentions
                              ? _c(
                                  "div",
                                  { staticClass: "pb-2" },
                                  [
                                    _c(
                                      "ob1-liens-haut-bas",
                                      {
                                        attrs: {
                                          "button-id":
                                            _vm.selectedOffer.legalMentions
                                              .title.headerId,
                                          "button-label":
                                            _vm.selectedOffer.legalMentions
                                              .title.title,
                                          "collapsed-block-id":
                                            _vm.selectedOffer.idSeo +
                                            "-" +
                                            _vm.selectedOffer.legalMentions
                                              .title.textId,
                                        },
                                      },
                                      _vm._l(
                                        _vm.selectedOffer.legalMentions
                                          .mentions,
                                        function (mention, index) {
                                          return _c(
                                            "div",
                                            {
                                              key:
                                                "mentiontext-" +
                                                _vm.selectedOffer.idSeo +
                                                "-" +
                                                index,
                                            },
                                            [
                                              mention.title
                                                ? _c("strong", [
                                                    _vm._v(
                                                      _vm._s(mention.title)
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              mention.text
                                                ? _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        mention.text
                                                      ),
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.activeView === "price-content"
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 px-2 px-md-3 px-lg-5" },
                      [
                        _c("PriceDetailsContent", {
                          attrs: {
                            id: _vm.selectedOffer.seoId,
                            "offer-type": _vm.selectedOffer.offerType,
                            "offer-name": _vm.selectedOffer.secondaryShortLabel,
                            "offer-price": _vm.selectedOffer.price,
                            "price-details":
                              _vm.selectedOffer.priceDetailsPopin,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "sticky-bottom py-2 bg-white modal-footer d-flex justify-content-center",
              },
              [
                _c("button", {
                  staticClass: "btn btn-primary px-3",
                  staticStyle: { "padding-left": "0", "padding-right": "0" },
                  attrs: {
                    type: "button",
                    "data-oevent-category":
                      _vm.selectedOffer.selectButtonTms.category,
                    "data-oevent-action":
                      _vm.selectedOffer.selectButtonTms.action,
                    "data-oevent-label":
                      _vm.selectedOffer.selectButtonTms.label,
                  },
                  domProps: {
                    textContent: _vm._s(_vm.selectedOffer.selectButtonLabel),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.addMobileOfferInCart(
                        _vm.selectedOffer.seoId,
                        _vm.selectedOffer
                      )
                    },
                  },
                }),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn-close pt-2 pt-md-0",
        staticStyle: { display: "block !important" },
        attrs: {
          type: "button",
          "data-bs-dismiss": "modal",
          "aria-label": "Fermer",
        },
      },
      [
        _c("span", {
          staticClass: "icon icon-delete",
          attrs: { "aria-hidden": "true" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }